import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDebouncedCallback } from '@/utils'
import { Insurance } from '@/types/insurance'
import { Categories } from '@/enums'

export const useInsuranceSearch = (insurances: Insurance[]) => {
  const { t } = useTranslation()
  const [search, setSearch] = useState('')

  const debouncedSearch = useDebouncedCallback((input: string) => {
    setSearch(input)
  }, 150)

  const filteredInsurances = useMemo(() => {
    if (!search.trim()) return insurances

    const searchLower = search.toLowerCase()
    return insurances.filter((insurance) => {
      const category =
        Categories[insurance.categoryId as keyof typeof Categories]
      const categoryName = t(`categories.${category.key}.name`).toLowerCase()

      return (
        insurance.carrierName.toLowerCase().includes(searchLower) ||
        categoryName.includes(searchLower) ||
        insurance.insuranceId.toLowerCase().includes(searchLower) ||
        (insurance.risksInsured?.toLowerCase().includes(searchLower) ?? false)
      )
    })
  }, [insurances, search, t])

  return {
    search,
    setSearch,
    debouncedSearch,
    filteredInsurances,
  }
}
